<ng-container *ngIf="editMode">
  <!-- Hidden file input allowing multiple file selection -->
  <input
    type="file"
    accept="image/png, image/jpeg, image/jpg"
    multiple
    #fileInput
    class="hidden-file-input"
    (change)="onFilesSelected($event)"
  />
  <span>
    <label style="font-size: 12px; color: gray">
      {{ "PAGE.LABELS.MAXIMUM_2_FILES_CAN_BE_UPLOADED" | translate }}
    </label>
  </span>
  <!-- Button to trigger the file input -->
  <sra-input-field
    [value]="notes"
    (userInput)="handleUserInput($event)"
    type="text"
    (validationStatus)="handleValidation($event)"
    [placeholder]="'PAGE.LABELS.ADD_ATTACHMENT_OR_NOTES' | translate"
    [customClass]="'has-action'"
    [maxLength]="numberConstants.MAX_NOTES_LENGTH"
    [showCharCount]="true"
  >
    <span class="action-button" *ngIf="connectionStatus">
      <sra-icon-button size="sm" (buttonClick)="openFileBrowser()">
        <sra-svg-icons
          name="attachment"
          title="Add attachment"
          className="icon-attachment icon-size-12"
          ariaHidden="false"
          focusable="false"
        />
      </sra-icon-button>
    </span>

    <!-- Display the selected images with remove buttons -->
    <div class="app-c-file-upload-wrapper" *ngIf="imageUrls.length > 0">
      <div class="selected-image-stack">
        <div
          class="selected-image-wrapper"
          *ngFor="let img of imageUrls; let i = index"
        >
          <img
            class="selected-image"
            [src]="img"
            [class.image-uploading]="showImageLoader(i)"
            alt="Selected Image"
          />
          <span class="image-loader-overlay" *ngIf="showImageLoader(i)">
            <span class="image-spinner"></span>
          </span>
          <span class="selected-image-actions">
            <sra-icon-button
              *ngIf="canShowDelete(i)"
              size="sm"
              (buttonClick)="removeImage(i)"
            >
              <sra-svg-icons
                name="delete"
                title="Remove attachment"
                className="icon-delete icon-size-24"
                ariaHidden="false"
                focusable="false"
              />
            </sra-icon-button>
          </span>
        </div>
      </div>
    </div>
    <div
      class="upload-actions-wrapper"
      *ngIf="showCancelAction && imageUrls.length > 0"
    >
      <sra-button
        id="cancel-edit"
        class="cancel-button"
        (click)="handleCancel()"
        hierarchy="link"
        ariaLabel="cancel"
        [label]="'PAGE.LABELS.CANCEL' | translate"
        size="sm"
      ></sra-button>
    </div>
  </sra-input-field>
</ng-container>

<div class="view-only-section" *ngIf="!editMode">
  <h5 *ngIf="notes && notes.trim().length > 0">Note</h5>
  <p *ngIf="notes && notes.trim().length > 0" class="view-only-data">
    {{ notes }}
  </p>

  <!-- Show saved images -->
  <div class="view-image-stack" *ngIf="urls.length > 0">
    <div class="view-image-wrapper" *ngFor="let url of urls; let i = index">
      <img class="view-image" [src]="url" alt="view Image" />
      <span class="view-image-actions">
        <sra-icon-button size="sm">
          <sra-svg-icons
            name="eye"
            title="view attachment"
            className="icon-eye icon-size-24"
            ariaHidden="false"
            focusable="false"
            (click)="openPopup(i)"
          />
        </sra-icon-button>
      </span>
      <sra-popup
        #popup
        [showHeader]="false"
        [showFooter]="false"
        [isImagePopup]="true"
        [showDownload]="true"
        [downloadUrl]="url"
      >
        <img class="view-popup-image" [src]="url" alt="view Image" />
      </sra-popup>
    </div>
  </div>

  <div class="upload-actions-wrapper" *ngIf="!editMode">
    <sra-button
      id="edit"
      (click)="toggleEditMode()"
      hierarchy="link"
      ariaLabel="edit"
      label="Edit"
      size="sm"
    ></sra-button>
  </div>
</div>
